import { HamburgerIcon } from '@ra-solutions/hamburger-icon'
import { HamburgerMenu } from '@ra-solutions/hamburger_menu'

const components = {
  HamburgerIcon,
  HamburgerMenu
}
export { components };